import { render, staticRenderFns } from "./paperResult.vue?vue&type=template&id=27ade7cc&scoped=true"
import script from "./paperResult.vue?vue&type=script&lang=js"
export * from "./paperResult.vue?vue&type=script&lang=js"
import style0 from "./paperResult.vue?vue&type=style&index=0&id=27ade7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ade7cc",
  null
  
)

export default component.exports